import { useEffect, useRef, useState } from 'react';

export default function ReCaptchaBox({
  siteKey,
  action = 'FORM_SUBMIT',
  onToken,
}) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  // 1) load the enterprise.js script once
  useEffect(() => {
    if (window.grecaptcha?.enterprise) {
      setLoaded(true);
      return;
    }

    window.__recaptchaOnload = () => setLoaded(true);
    const s = document.createElement('script');
    s.src =
      'https://www.google.com/recaptcha/enterprise.js?onload=__recaptchaOnload&render=explicit';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }, []);

  // 2) render the widget when ready
  useEffect(() => {
    if (!loaded || !containerRef.current || widgetIdRef.current != null) return;

    widgetIdRef.current = window.grecaptcha.enterprise.render(
      containerRef.current,
      {
        sitekey: siteKey,
        action,
        callback: (token) => onToken?.(token),
        'expired-callback': () => onToken?.(''),
        'error-callback': () => onToken?.(''),
        theme: 'light', // or 'dark'
        size: 'normal', // or 'compact'
      },
    );
  }, [loaded, siteKey, action, onToken]);

  return <div ref={containerRef} />; // reCAPTCHA inserts into this div
}
